<template>
<div class='upload'>
  <!-- <el-dialog title='账号认证' :visible.sync='rzFormVisible' custom-class='dialog-t' width='677px' :before-close='clearDl'>
    <div class='form'>

    </div>
    <div slot='footer' class='dialog-footer'>
      <el-button type='primary' @click='regist'>确 定</el-button>
    </div>
    </el-dialog> -->
    <ul>
      <li class='rz-text'>
        <span class='label'>银行卡</span>
        <div class='po'>
          <img alt='' v-if='form.bank_card' :width='180' :height='105' ref='img'>
          <div v-else class='ic'>
            <img src='/static/img/po.png' alt=''>
            <p>点击上传银行卡照片</p>
          </div>
          <input type='file' name='' id='' class='input-f' accept='image/*' @change='selectBankC' ref='fileinput'>
        </div>

      </li>
      <li class='rz-text'>
        <span class='label'>卡主姓名</span>
        <input type='text' class='text' v-model='form.name'>
      </li>
      <li class='rz-text'>
        <span class='label'>上传身份证照片</span>
        <div>
          <div class='po mb'>
            <img alt='' v-if='form.ID_card_front' :width='180' :height='105' ref='img2'>
            <div v-else class='ic'>
              <img src='/static/img/po.png' alt=''>
              <p>身份证正面</p>
            </div>
            <input type='file' name='' id='' class='input-f' accept='image/*' @change='selectIDCF' ref='fileinput2'>
          </div>
          <div class='po'>
            <img alt='' v-if='form.ID_card_back' :width='180' :height='105' ref='img3'>
            <div v-else class='ic'>
              <img src='/static/img/po.png' alt=''>
              <p>身份证反面</p>
            </div>
            <input type='file' name='' id='' class='input-f' accept='image/*' @change='selectIDCB' ref='fileinput3'>
          </div>
        </div>
      </li>
    </ul>
    <button class='r-btn' @click='submit'>确定</button>
</div>
</template>

<script>
export default {
  name: 'uploadImg',
  data () {
    return {
      imgDataUrl: [],
      form: {
        name: '',
        bank_card: null,
        ID_card_front: null,
        ID_card_back: null
      },
      picSize: 2
    }
  },
  methods: {
    cleanDl() {
      this.form = {
        name: '',
        bank_card: null,
        ID_card_front: null,
        ID_card_back: null
      }
    },
    // name ref
    fileSize(file, item, name, fName) {
      let fileSize = file.size / 1024
      if (fileSize > (this.picSize * 1024)) {
        if (!window.FileReader || !window.Blob) {
          this.$alert(`图片大小不能超过${this.picSize}MB`, '温馨提示', {
            confirmButtonText: '确定'
          })
          this.$refs[fName].value = ''
          return
        }
      }
      this.form[item] = file
      this.readFile(file, name, item)
    },
    readFile(file, name, item, callback) {
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(file)
      // console.log('********原始图片文件********')
      // console.log(file)
      reader.onload = (e) => {
        // console.log('********读取图片文件********')
        // console.log(e.target)
        self.$refs[name].src = e.target.result
        let fileSize = file.size / 1024
        self.form[`${item}_name`] = file.name
        if (fileSize > (this.picSize * 1024)) {
          let result = e.target.result
          let img = new Image()
          img.src = result
          // console.log('********未压缩前的图片大小********')
          // console.log(result.length / 1024 / 1024)
          img.onload = () => {
            let data = self.compress(img)
            let blob = self.dataURItoBlob(data)
            // console.log('*******base64转blob对象******')
            // console.log(blob)
            // console.log(blob.size / 1024 / 1024)
            self.form[item] = blob
            self.form[`${item}_name`] = new Date().getTime() + '.jpeg'
          }
        }
      }
    },
    selectBankC(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0]  // 提交的图片
        this.fileSize(file, 'bank_card', 'img', 'fileinput')
      }
    },
    selectIDCF(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0]  // 提交的图片
        this.fileSize(file, 'ID_card_front', 'img2', 'fileinput2')
      }
    },
    selectIDCB(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0]  // 提交的图片
        this.fileSize(file, 'ID_card_back', 'img3', 'fileinput3')
      }
    },
    submit() {
      if (!this.form.bank_card) {
        this.$alert('请选择银行卡照片', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      } else if (!this.form.name) {
        this.$alert('姓名不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      } else if (!this.form.ID_card_front) {
        this.$alert('请选择身份证正面照片', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      } else if (!this.form.ID_card_back) {
        this.$alert('请选择身份证反面照片', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      this.$emit('submitupload', this.form)
    },
    // 压缩图片
    compress(img) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      // let initSize = img.src.length
      // console.log(initSize)
      let width = img.width / 2
      let height = img.height / 2
      canvas.width = width
      canvas.height = height
      // 铺底色
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, width, height)

      // 进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', 0.92)
      // console.log('*******压缩后的图片大小*******')
      // console.log(ndata)
      // console.log(ndata.length)
      return ndata
    },
    // base64转成bolb对象
    dataURItoBlob(base64Data) {
      var byteString
      if (base64Data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(base64Data.split(',')[1])
      } else {
        byteString = unescape(base64Data.split(',')[1])
      }
      var mimeString = base64Data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    }
  }
}
</script>

<style lang='stylus' scoped>
.upload
  padding 45px 0
  text-align center
  .rz-text
    margin-bottom 8px
    overflow hidden
    padding-left 130px
    display flex
    .label
      font-size 14px
      color #959595
      width 100px
      margin-right 20px
      text-align right
      line-height 32px
      height 32px
    .text
      width 180px
      height 32px
      color #959595
      font-size 13px
      line-height 32px
      border solid 1px #dcdcdc
      border-radius 2px
      text-indent 1em
      outline none
      background none
    .po
      position relative
      width 180px
      height 105px
      border solid 1px #dcdcdc
      border-radius 2px
      cursor pointer
      justify-content center
      // align-items center
      display flex
      &.mb
        margin-bottom 8px
      .ic
        & > img
          padding-top 20px
        & > p
          text-align center
          color #959595
          font-size 14px
          margin-top 8px
      .input-f
        width 180px
        height 105px
        position absolute
        z-index 1000
        top 0
        left 0
        right 0
        opacity 0
        cursor pointer
  .r-btn
    margin-top 25px
    width 159px
    height 40px
    background #288cea
    color #fff
    font-size 16px
    border 0
    outline none
    cursor pointer
    border-radius 2px
</style>



// WEBPACK FOOTER //
// uploadImg.vue?70e802c2